import React, { useState } from "react";
import Box from "@mui/material/Box";
import { makeStyles } from "@mui/styles";
import { Grid } from "@material-ui/core";
import Typography from "@mui/material/Typography";
import { BootstrapButton } from "layouts/profile/GuestLoginForm/components/OccupancyButton";
import { getCountOfFiltersInRat,makeOccupancyTypeActive } from "../../../../redux/actions/GuestActions";
import { getBedsByColorFilter } from "../../../../redux/actions/RatActions";
import { useSelector,useDispatch } from "react-redux";
const useStyles = makeStyles(() => ({
  activeButton: {
    background: "#139c15",
  },
  box: {
    width: "100%",
  },
}));
export default function OccupancyFilters({buildingId,getYear}) {
  const classes = useStyles();
  const [occupancyType, setOccupancyType] = useState("");
  const [activeButton, setActiveButton] = useState();
  const dispatch=useDispatch();
  const clickedButtonHandler = (e) => {
    const { name } = e.target.value;
    setActiveButton(e.target.value);
    setOccupancyType(e.target.value);
    getYear(e.target.value)
    dispatch(getBedsByColorFilter(buildingId,e.target.value))
    dispatch(getCountOfFiltersInRat(buildingId,e.target.value))
  };
  return (
    <Box className={classes.box}>
      <Grid
        item
        xs={12}
        style={{
          alignItems: "center",
          marginLeft: "auto",
          marginRight: "auto",
          width: "69%",
          paddingTop: 20,
        }}
      >
        <Grid container item spacing={3}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Typography variant="h5" align="center" component="div" pb="0px">
              Filter based on Occupancy Type
            </Typography>
          </Grid>{" "}
        </Grid>
        <Grid item container spacing={1} alignItems="center">
          <Grid item xs={12} sm={6} md={4} lg={4}>
            <BootstrapButton
              variant="contained"
              disableRipple
              value="Regular"
              style={{ width: "70%", height: "100%" }}
              onClick={clickedButtonHandler}
              className={
                activeButton === "Regular" ? `${classes.activeButton}` : ""
              }
            >
              Regular
            </BootstrapButton>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={4}>
            <BootstrapButton
              variant="contained"
              disableRipple
              style={{ width: "70%", height: "100%" }}
              value="OneMonth"
              className={
                activeButton === "OneMonth" ? `${classes.activeButton}` : ""
              }
              onClick={clickedButtonHandler}
            >
              One Month
            </BootstrapButton>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={4}>
            <BootstrapButton
              variant="contained"
              disableRipple
              style={{ width: "70%", height: "100%" }}
              value="daily"
              className={
                activeButton === "daily" ? `${classes.activeButton}` : ""
              }
              onClick={clickedButtonHandler}
            >
              Daily
            </BootstrapButton>{" "}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}
